import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Papa from 'papaparse';
import { FaFileExcel } from 'react-icons/fa';
import moment from 'moment';

const GenereCsv = ({ data, fichier, go, setGo, visible }) => {


    const downloadCSV = () => {
        const csv = Papa.unparse({
            fields: Object.keys(data[0]),
            data: JSON.parse(JSON.stringify(data)),
            // data: JSON.parse(JSON.stringify(data).replace(/{}/g, '""').replace(/null/g, '""')),
        }, { delimiter: ';' });

        const  universalBOM = "\uFEFF";

        const blob = new Blob([universalBOM+csv], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');

        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `Export_${fichier}_${moment().format('YYYYMMDDHHmmss')}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    useEffect(() => {
        if (go) {
            downloadCSV();
            setGo(false);
        }
    }, [go]);

    const handlePdf = (e) => {

        e.stopPropagation();
        downloadCSV();
    }

    return (
        <>
            {visible !== false && <Button variant="outline-success" onClick={(e) => handlePdf(e)}><FaFileExcel /></Button>}
        </>
    );
}

export default GenereCsv;
